class ScrollDirection {
  constructor () {
    this.lastScrollTop = 0
    this.ticking = false
    this.lastDirection = ''

    this.init()
  }

  init () {
    window.addEventListener('scroll', this.onScroll.bind(this), {
      passive: true,
    })
  }

  onScroll () {
    if (!this.ticking) {
      window.requestAnimationFrame(() => this.handleScroll())
      this.ticking = true
    }
  }

  handleScroll () {
    const currentScrollTop = document.documentElement.scrollTop
    const bodyElement = document.body
    let currentDirection = ''

    if (currentScrollTop > this.lastScrollTop) {
      currentDirection = 'down'
    } else if (currentScrollTop < this.lastScrollTop) {
      currentDirection = 'up'
    }

    if (currentDirection && currentDirection !== this.lastDirection) {
      bodyElement.setAttribute('data-scroll-direction', currentDirection)
      this.lastDirection = currentDirection
    }

    this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop
    this.ticking = false
  }
}

export const scrollDirection = new ScrollDirection()
